/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';
import { ReactComponent as Logo } from 'assets/images/logo-2-color-no-padding.svg';
import { ReactComponent as SupportCenterIcon } from 'assets/icons_3/support.svg';
import { ReactComponent as TelegramIcon } from 'assets/icons_3/telegram.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/icons_3/whatsapp.svg';
import { ReactComponent as WebIcon } from 'assets/icons_3/web.svg';
import { ReactComponent as LockIcon } from 'assets/icons_3/lock.svg';
import { ReactComponent as WarningIcon } from 'assets/icons_3/alert-triangle2.svg';
import LanguageSelector from 'components/LanguageSelector/LanguageSelector';
import ResetPasswordForm from 'components/Auth/ResetPasswordForm/ResetPasswordForm';
import LoginForm from 'components/Auth/LoginForm';
import OtpFrom from 'components/Auth/OtpForm';
import { useAppSelector } from 'hooks';
import { useTranslation } from 'react-i18next';
import LinkButton from 'components/UI_kit_3/Button/LinkButton';
import Alert from 'components/UI_kit_3/Alert/Alert';
import { getIdleLogoutMinutes } from 'utils/session-activity';
// import RouterLinkButton from 'components/UI_kit_3/Button/RouterLinkButton';
import adsPart1Ru from '../../assets/images/ads_part_1_ru.jpg';
import adsPart1En from '../../assets/images/ads_part_1_en.jpg';
import adsPart2Ru from '../../assets/images/ads_part_2_ru.jpg';
import adsPart2En from '../../assets/images/ads_part_2_en.jpg';
import adsPart3 from '../../assets/images/ads_part_3.jpg';
import adsKzPart1Ru from '../../assets/images/ads_kz_part_1_ru.png';
import adsKzPart1En from '../../assets/images/ads_kz_part_1_en.png';
import styles from './auth.module.scss';

const AuthPage = () => {
  const [t, i18n] = useTranslation();
  const user = useAppSelector((state) => state.user);
  const rightAsideRef = useRef<HTMLDivElement>(null);
  const idleLogoutMinutes = getIdleLogoutMinutes();

  return (
    <main className={classNames(styles.authPage)}>
      <Helmet>
        {`${t('auth.self')} | ${process.env.REACT_APP_PROJECT_TITLE}`}
      </Helmet>
      {(user.state === 'expired' || user.state === 'new') && (
        <div className={styles.resetPasswordView}>
          <div className={styles.resetPasswordInner}>
            <Logo className={classNames(styles.logo, 'mb-5xl')} />
            <div className={classNames(styles.lockIcon, 'mb-3xl')}>
              <LockIcon />
            </div>
            <h2 className="mb-3xl">{t('auth.password_creation')}</h2>
            <ResetPasswordForm />
          </div>
        </div>
      )}
      {(user.state === 'login' || user.state === '2fa') && (
        <>
          <aside className={classNames(styles.side, styles.auth)}>
            {user.state === 'login' && idleLogoutMinutes > 0 && (
              <Alert
                className={classNames(styles.sessionAlert, 'my-3xl')}
                variant="warning"
                Icon={<WarningIcon />}
                message={t('auth.session_idle_logout', { count: idleLogoutMinutes })}
                qa-element="auth-session-idle"
              />
            )}
            <div className={styles.sideInner}>
              <LanguageSelector className={styles.authLang} />
              <Logo className={classNames(styles.logo, 'mb-8xl')} />
              <div className={styles.form}>
                {
                  user.state === 'login' && (
                    <>
                      <h2 className="mb-xl" qa-element="auth-signin">{t('auth.signin')}</h2>
                      <div className={classNames('mb-4xl', styles.subTitle)} qa-element="auth-signin">{t('auth.please_type_your_data')}</div>
                      <LoginForm />
                      {/* <div className={styles.signUp}>
                        <span>{t('self_registration.no_account')}</span>
                        <RouterLinkButton variant="link" to="/registration" qa-element="to-registration">
                          {t('auth.to_sign_up')}
                        </RouterLinkButton>
                      </div> */}
                    </>
                  )
                  }
                {
                user.state === '2fa' && (
                  <>
                    <h2 qa-element="auth-signin">{t('auth.signin')}</h2>
                    <OtpFrom />
                  </>
                )
              }
              </div>
            </div>
            <div className={styles.links}>
              <ul className={styles.linksList}>
                <li>
                  <LinkButton prefixIcon={<SupportCenterIcon />} href="https://helpdesk.pro-data.tech" target="_blank" rel="noreferrer">
                    <span>{t('auth.support')}</span>
                  </LinkButton>
                </li>
                {window.location.host.includes('kz-1') ? (
                  <li>
                    <LinkButton prefixIcon={<WhatsAppIcon />} href="https://wa.me/77475073022" target="_blank" rel="noreferrer">
                      <span>{t('auth.whatsapp')}</span>
                    </LinkButton>
                  </li>
                )
                  : (
                    <li>
                      <LinkButton prefixIcon={<TelegramIcon />} href="https://t.me/PRO_DATA_Support_Bot" target="_blank" rel="noreferrer">
                        <span>{t('auth.telegram')}</span>
                      </LinkButton>
                    </li>
                  )}
                <li>
                  <LinkButton prefixIcon={<WebIcon />} href="https://pro-data.tech" target="_blank" rel="noreferrer">
                    <span>{t('auth.website')}</span>
                  </LinkButton>
                </li>
              </ul>
              <div className={styles.rights}>{window.location.host.includes('kz-1') ? t('common.rights_kz') : t('common.rights')}</div>
            </div>
          </aside>
          {!window.location.host.includes('kz-1') ? (
            <aside
              ref={rightAsideRef}
              className={classNames(styles.side, styles.ads, styles.adsUz)}
            >
              <div className={classNames(styles.adsInner)}>
                <div>
                  <div>
                    <img src={i18n.language === 'ru' ? adsPart1Ru : adsPart1En} alt="GPU Ads" className="mb-4" />
                    <img src={i18n.language === 'ru' ? adsPart2Ru : adsPart2En} alt="GPU Ads" />
                  </div>
                  <div>
                    <img src={adsPart3} alt="GPU Ads" />
                  </div>
                  <LinkButton
                    variant="primary"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.book}
                    href="https://www.pro-data.tech/GPU-server/"
                  >
                    {t('common.book')}
                  </LinkButton>
                </div>
              </div>
            </aside>
          )
            : (
              <aside
                ref={rightAsideRef}
                className={classNames(styles.side, styles.ads, styles.adsKz)}
              >
                <div className={classNames(styles.adsInner)}>
                  <div>
                    <div>
                      <img src={i18n.language === 'ru' ? adsKzPart1Ru : adsKzPart1En} alt="S3 Ads" className="mb-4" />
                    </div>
                    <LinkButton
                      variant="primary"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.book}
                      href="https://www.pro-data.tech/object-storage/"
                    >
                      {t('common.more')}
                    </LinkButton>
                  </div>
                </div>
              </aside>
            )}
        </>
      )}
    </main>
  );
};

export default AuthPage;
